interface BuildAccessStateInput {
  hasEntitlement: boolean;
  isExpired: boolean;
}

export interface AccessState {
  title: string;
  description: string;
  primaryActionLabel: string;
  /** Soft continue path when the learner already has active access. */
  secondaryActionLabel?: string;
  alreadyEntitledHint?: string;
}

export function buildAccessState(input: BuildAccessStateInput): AccessState {
  if (input.hasEntitlement && input.isExpired) {
    return {
      title: '练习权限已过期',
      description: '你可以重新兑换授权码，恢复诊断和训练权限。',
      primaryActionLabel: '重新兑换',
    };
  }

  if (input.hasEntitlement) {
    return {
      title: '兑换考试空间',
      description: '已有可用权限时仍可继续兑换，开通更多考试空间。',
      primaryActionLabel: '兑换并开始',
      secondaryActionLabel: '继续学习',
      alreadyEntitledHint: '当前账户已有可用练习权限。你可以继续学习，也可以再兑换新的授权码。',
    };
  }

  return {
    title: '兑换你的考试练习权限',
    description: '输入授权码后即可进入诊断和训练流程。',
    primaryActionLabel: '兑换并开始',
  };
}
